import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Pillar from "@/pages/Pillar";
import Connectivity from "@/pages/Connectivity";
import ProofOfPeace from "@/pages/ProofOfPeace";
import Event from "@/pages/Event";
import PublicPass from "@/pages/PublicPass";
import FAQ from "@/pages/FAQ";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Contact from "@/pages/Contact";
import StrategyCall from "@/pages/StrategyCall";
import EOI from "@/pages/EOI";
import Reserve from "@/pages/Reserve";
import TrackRecord from "@/pages/TrackRecord";
import VersusComparisons from "@/pages/VersusComparisons";
import AdminLogin from "@/pages/AdminLogin";
import AdminPortal from "@/pages/AdminPortal";
import Portal from "@/pages/Portal";
import CrmApp from "@/pages/CrmApp";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/pillars/:slug" element={<Pillar />} />
          <Route path="/strategy-call" element={<StrategyCall />} />
          <Route path="/connectivity" element={<Connectivity />} />
          <Route path="/proof-of-peace" element={<ProofOfPeace />} />
          <Route path="/event" element={<Event />} />
          <Route path="/pass/:id" element={<PublicPass />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/track-record" element={<TrackRecord />} />
          <Route path="/vs" element={<VersusComparisons />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/eoi" element={<EOI />} />
          <Route path="/reserve" element={<Reserve />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/portal" element={<AdminPortal />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        {/* Owners portal + CRM back-office — separate chrome (own header,
            no site nav / footer / mascot / popups). Nested Routes inside
            the components handle their own sub-paths. */}
        <Route path="/portal/*" element={<Portal />} />
        <Route path="/crm/*" element={<CrmApp />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
